module.exports = __webpack_public_path__ + "media/images/flags/32/Kosovo-1386ad0fbfda24b36792823acd564d41.png";